/* components/SiteHeader.ts
Global Site Header

Example
<site-header>
    Site header content here
</site-header>
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { DrawerContainer } from '../Drawer/DrawerContainer';
import { cart } from '@/theme/Cart';

@Component
export class SiteHeader extends ThemeComponent {

    @Ref() row!: HTMLDivElement;
    @Ref({required: false}) cartTrigger!: HTMLDivElement;
    @Ref() iconCount!: HTMLSpanElement;

    private heroBanner: HTMLDivElement | null;

    constructor() {
        super();
        this.heroBanner = document.querySelector('.hero');
    }

    init() {
        this.$subscribe(cart.onChange, () => {
            const cartCount = Number(cart.getCartItemCount());
            if (cartCount > 0) {
                this.iconCount.classList.remove('visibility-hidden');
            } else {
                this.iconCount.classList.add('visibility-hidden');
            }
            this.iconCount.textContent = String(cartCount);
        });

        this.handleBannerPadding();
        this.initializeResizeHandler();
    }

    /**
     * Handle Body Padding.
     */
    private handleBannerPadding() {
        const height = this.row.offsetHeight;
        if (this.heroBanner) {
            this.heroBanner.style.paddingTop = `${height}px`;
        }
    }

    initializeResizeHandler() {
        let resizeTimer: number;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(() => {
                this.handleBannerPadding();
            }, 300);
        });
    }
}
